export class EntDepartmentFilter {
    page: number = 1;
    size: number = 30;
    name: string | null = null;
    governmentIds: number[] | null = null;
    createdFrom: string | null = null;
    parentId: number | null = null;
    createdTo: string | null = null;
    deleted: boolean = false;
}
